import { nf, pct, sec, cnt } from "./format";

// 시안 kpi(): goTo 가 있으면 버튼(다른 메뉴로 이동)
function Kpi({ ic, col, bg, n, l, d, onGo }) {
    const Tag = onGo ? "button" : "div";
    return (
        <Tag className={`kpi ${onGo ? "link" : ""}`} style={{ "--kc": col, borderColor: "var(--line)" }} onClick={onGo} type={onGo ? "button" : undefined}>
            <span className="ic" style={{ background: bg, color: col }}><i className={`fa-solid ${ic}`}></i></span>
            <div><div className="n">{n}</div><div className="l">{l}</div><div className="d">{d}</div></div>
        </Tag>
    );
}

const Qm = ({ n, l, f }) => (
    <div className="qm"><div className="n">{n}</div><div className="l">{l}</div><div className="f">{f}</div></div>
);

export function Kpis({ o, go }) {
    const res = o.inquiry_resolution || {};
    return (
        <div className="kpis">
            <Kpi ic="fa-comments" col="#2563eb" bg="#e8efff" n={nf(o.conversations_total)} l="대화량" d={`최근 ${o.days}일 챗봇 대화`} onGo={() => go("chat_history")} />
            <Kpi ic="fa-circle-check" col="#15803d" bg="#e3f5ea" n={pct(res.rate)} l="문의 해결률" d={`완료 ${nf(res.completed)}건 ÷ 전체 ${nf(res.total)}건`} onGo={() => go("inquiry")} />
            <Kpi ic="fa-circle-exclamation" col="#dc2626" bg="#fdeeee" n={cnt(o.open_inquiries)} l="미처리 문의" d="접수 · 처리중 · 보류 합계" onGo={() => go("inquiry")} />
            <Kpi ic="fa-clock" col="#b45309" bg="#fff3dc" n={sec(o.avg_first_response_sec)} l="평균 응답시간" d="질문 후 챗봇 첫 답변까지" onGo={() => go("chart")} />
        </div>
    );
}

export function Quality({ o }) {
    const q = o.quality || {};
    return (
        <div className="panel">
            <div className="pn-h"><h3>로그 기반 품질 지표</h3><span className="hint">가맹점주가 버튼을 누르지 않아도 대화 로그와 문의 상태에서 자동 산출</span><span className="sp"></span><span className="hint">최근 {o.days}일</span></div>
            <div className="pn grid3">
                <Qm n={pct(q.requery_rate)} l="재질문율" f="같은 세션 안에서 비슷한 질문을 다시 한 비율" />
                <Qm n={pct(q.escalation_rate)} l="확인필요 발생률" f="상담 연결(문의 전환) ÷ 전체 대화" />
                <Qm n={cnt(q.backlog_late)} l="미처리 적체" f="접수 후 2시간 넘게 담당자 미지정" />
            </div>
        </div>
    );
}
